import { CardHeader, CardHeaderProps } from '@material-ui/core';
import React from 'react';
import styles from './SGSCardHeader.module.scss';

type Props = CardHeaderProps & {
    color?: 'primary' | 'secondary' | 'midblue' | 'danger' | 'dark';
    title: React.ReactNode;
};

const SGSCardHeader: React.FC<Props> = ({ color = 'primary', ...props }) => {
    return <CardHeader {...props} classes={{ root: `${styles['card-header']} ${styles['card-header-' + color]}`, title: styles.title }} />;
};

export default SGSCardHeader;
